import {createDivIn, createSpanIn} from '../ui_utils/DomUtils'

export class UIReconnectingBackgroundView {
    private static connectionLostBackground: HTMLDivElement | undefined

    static show() {
        if(this.connectionLostBackground != undefined) return

        const overlay = createDivIn(document.body, 'game-reconnecting-overlay')
        createDivIn(overlay, 'loading-spinner')
        createSpanIn(overlay, 'game-reconnecting-text', {key: 'strings:game.gameState.gameLogs.gameDisconnected.reconnecting'})

        this.connectionLostBackground = overlay
    }

    static remove() {
        if(this.connectionLostBackground != undefined) this.connectionLostBackground.remove()
        this.connectionLostBackground = undefined
    }
}
